module.exports = __webpack_public_path__ + "static/img/help_11ques_01.2f3399c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_11ques_01.png
// module id = 325
// module chunks = 140